module.exports = __webpack_public_path__ + "fonts/category-icons--e6247f0bfbde38e7937051e1ebe4b6fd.e6247f0bfbde38e7937051e1ebe4b6fd.woff";